import { useMemo } from 'react';
import { useRouteMatch } from 'react-router';

/**
 * Checks if the app has been loaded within a marketing `iframe`.
 *
 * See https://vendor.gobonfire.com/
 *
 * @returns {Boolean} Returns `true` if an `iframe` is detected, otherwise `false`.
 */
export const checkMarketingiFrameExists = () => {
  // Cypress automatically frames the app when running tests, so it's safe to ignore in
  // that context. This will also throw if you try to frame the app outside of a
  // non-bonfirehub.ca/com domain (e.g. when testing changes locally).
  try {
    if (window?.parent && 'Cypress' in window.parent) {
      return false;
    }
    // eslint-disable-next-line no-empty
  } catch (err) {}

  return window !== window?.parent;
};

const WHITELISTED_IFRAME_ROUTES = ['/preview'];

/**
 * Checks if the current route is whitelisted for the marketing `iframe`.
 *
 * @returns {Boolean} Returns `true` if the current route isn't whitelisted, otherwise `false`.
 */
export const useMarketingRedirect = () => {
  const isMarketingiFrame = checkMarketingiFrameExists();
  const match = useRouteMatch(WHITELISTED_IFRAME_ROUTES);

  return useMemo(() => isMarketingiFrame && !match, [isMarketingiFrame, match]);
};
